<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card v-show="!loading">
      <v-toolbar flat dense elevation="1" class="mb-1">
        <v-toolbar-title
          :class="$vuetify.breakpoint.mobile ? 'toolbar-title-mobile' : ''"
        >
          <span class="font-weight-medium">Exportar para Excel</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text fab small @click="fechar">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="my-list mx-3">
        <fieldset class="px-3 pb-3">
          <legend>Escolha os campos da Inscrição</legend>
          <v-checkbox
            v-model="colunasInscricao"
            dense
            outlined
            hide-details="auto"
            v-for="(item, index) in getColunasInscricao"
            :key="index"
            :label="item.texto"
            :value="item"
          ></v-checkbox>
        </fieldset>
        <fieldset class="px-3 pb-3">
          <legend>Escolha os campos do Candidato</legend>
          <v-checkbox
            v-model="colunasCandidato"
            dense
            outlined
            hide-details="auto"
            v-for="(item, index) in getColunasCandidato"
            :key="index"
            :label="item.texto"
            :value="item"
          ></v-checkbox>
        </fieldset>
        <fieldset
          class="px-3 pb-3"
          v-if="
            ps.subprocesses && ps.subprocesses[0].inscriptionData.length > 0
          "
        >
          <legend>Escolha os campos do Formulário</legend>
          <v-checkbox
            v-model="colunasFormulario"
            dense
            outlined
            hide-details="auto"
            v-for="(item, index) in getColunasFormulario"
            :key="index"
            :label="item.texto"
            :value="item"
          ></v-checkbox>
        </fieldset>
        <fieldset
          class="px-3 pb-3"
          v-if="ps.subprocesses && ps.subprocesses[0].avaliationData.length > 0"
        >
          <legend>Escolha os campos de Avaliação</legend>
          <v-checkbox
            v-model="colunasAvaliacao"
            dense
            outlined
            hide-details="auto"
            v-for="(item, index) in getColunasAvaliacao"
            :key="index"
            :label="item.texto"
            :value="item"
          ></v-checkbox>
        </fieldset>
      </div>
      <v-divider class="mt-2"></v-divider>
      <fieldset class="px-3 pb-3 mx-3">
        <legend>Escolha por quais campos ordenar</legend>
        <v-autocomplete
          v-model="orderby"
          dense
          outlined
          hide-details="auto"
          small-chips
          :items="colunasEscolhidas"
          item-text="texto"
          item-value="field"
          multiple
        ></v-autocomplete>
      </fieldset>
      <fieldset class="px-3 pb-3 mx-3 mb-3">
        <legend>Escolha a ordem das colunas</legend>
        <v-autocomplete
          v-model="viewby"
          dense
          outlined
          hide-details="auto"
          small-chips
          :items="colunasEscolhidas"
          item-text="texto"
          item-value="texto"
          multiple
        ></v-autocomplete>
      </fieldset>

      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="end" class="pa-3">
          <v-btn
            class="my-1 mx-1"
            :block="$vuetify.breakpoint.mobile"
            elevation="0"
            color="primary"
            @click="fechar"
          >
            Voltar
          </v-btn>
          <v-btn
            class="my-1 mx-1"
            :block="$vuetify.breakpoint.mobile"
            color="primary"
            @click="generateXls"
          >
            Exportar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
    <LoadingDialog :loading="loading" />
  </v-dialog>
</template>

<script>
import LoadingDialog from "@/components/LoadingDialog.vue";
import xlsx from "xlsx";
import { saveAs } from "file-saver";
import arraySort from "array-sort";

export default {
  metaInfo: {
    title: "UNIFAP",
    // all titles will be injected into this template
    titleTemplate: "%s - DEPSEC",
  },
  name: "App",
  props: ["dialog", "inscriptions", "ps"],
  components: { LoadingDialog },
  data() {
    return {
      loading: false,
      colunasInscricao: [],
      colunasCandidato: [],
      colunasFormulario: [],
      colunasAvaliacao: [],
      colunasEscolhidas: [],
      orderby: [],
      viewby: [],
    };
  },
  watch: {
    colunasInscricao: function () {
      this.colunasEscolhidas = [
        ...this.colunasInscricao,
        ...this.colunasCandidato,
        ...this.colunasFormulario,
        ...this.colunasAvaliacao,
      ];
    },
    colunasCandidato: function () {
      this.colunasEscolhidas = [
        ...this.colunasInscricao,
        ...this.colunasCandidato,
        ...this.colunasFormulario,
        ...this.colunasAvaliacao,
      ];
    },
    colunasFormulario: function () {
      this.colunasEscolhidas = [
        ...this.colunasInscricao,
        ...this.colunasCandidato,
        ...this.colunasFormulario,
        ...this.colunasAvaliacao,
      ];
    },
    colunasAvaliacao: function () {
      this.colunasEscolhidas = [
        ...this.colunasInscricao,
        ...this.colunasCandidato,
        ...this.colunasFormulario,
        ...this.colunasAvaliacao,
      ];
    },
  },
  computed: {
    getColunasInscricao() {
      let colunas = [];
      if (this.ps.subprocesses && this.inscriptions.length > 0) {
        colunas.push({
          field: "inscriptionNumber",
          texto: "Número de Inscrição",
        });
        colunas.push({ field: "course", texto: "Curso Escolhido" });
        colunas.push({
          field: "vacancie",
          texto: "Tipo de Vaga",
          is_array: true,
        });
        colunas.push({
          field: "enem_total.total_selected",
          texto: "Nota ENEM",
        });
        colunas.push({
          field: "enem_total.total_bonus",
          texto: "Nota ENEM Bonificada",
        });
        if (this.ps.bonifications.length > 0) {
          colunas.push({
            field: "bonification",
            texto: "Bonificação Regional",
            is_array: true,
          });
        }
        if (this.ps.atendimento_especial) {
          colunas.push({
            field: "atendimento_especial",
            texto: "Atendimento Especial",
          });
          colunas.push({
            field: "atendimento_especial_tipo",
            texto: "Atendimento Especial Necessário",
          });
        }
        if (this.ps.is_paid) {
          colunas.push({
            field: "accepted_isencao",
            texto: "Situação da Isenção",
          });
          colunas.push({ field: "wants_isencao", texto: "Solicitou Isenção" });
          colunas.push({ field: "nis", texto: "NIS" });
          colunas.push({ field: "is_paid", texto: "Situação do Pagamento" });
        }
        if (this.inscriptions[0].room) {
          colunas.push({ field: "room", texto: "Local de Prova" });
        }
        colunas.push({ field: "status", texto: "Situação" });
        colunas.push({ field: "classification", texto: "Colocação" });
        colunas.push({ field: "createdAt", texto: "Data da Inscrição" });
        //avaliationData
      }
      return colunas;
    },
    getColunasCandidato() {
      let colunas = [];

      colunas.push({ field: "id_user.name", texto: "Nome" });
      colunas.push({ field: "id_user.social_name", texto: "Nome Social" });
      colunas.push({ field: "id_user.gender", texto: "Gênero" });
      colunas.push({ field: "id_user.cpf", texto: "CPF" });
      colunas.push({ field: "id_user.rg", texto: "RG" });
      colunas.push({ field: "id_user.rg_uf", texto: "Estado Emissor" });
      colunas.push({ field: "id_user.birthday", texto: "Data de Nascimento" });
      colunas.push({ field: "id_user.mother", texto: "Nome da Mãe" });
      colunas.push({ field: "id_user.father", texto: "Nome do Pai" });
      colunas.push({ field: "id_user.from", texto: "Nacionalidade" });
      colunas.push({ field: "id_user.natural", texto: "Naturalidade" });
      colunas.push({ field: "id_user.email", texto: "E-mail" });
      colunas.push({ field: "id_user.telephone", texto: "Telefone" });
      colunas.push({
        field: "id_user.address",
        texto: "Endereço",
        is_address: true,
      });
      colunas.push({ field: "id_user.cep", texto: "CEP" });
      colunas.push({ field: "id_user.city", texto: "Cidade" });
      colunas.push({ field: "id_user.state", texto: "Estado" });
      colunas.push({ field: "id_user.country", texto: "País" });

      return colunas;
    },
    getColunasFormulario() {
      let colunas = [];
      if (this.ps.subprocesses) {
        let inscriptionData = this.ps.subprocesses[0].inscriptionData;

        for (const field of inscriptionData) {
          colunas.push({ field: field.title, texto: field.title });
        }
      }
      return colunas;
    },
    getColunasAvaliacao() {
      let colunas = [];
      if (this.ps.subprocesses) {
        let avaliationData = this.ps.subprocesses[0].avaliationData;
        for (const av of avaliationData) {
          for (const field of av.fields) {
            colunas.push({
              title: av.title,
              field: field.title,
              texto: av.title + ": " + field.title,
            });
          }
        }
      }
      return colunas;
    },
  },
  methods: {
    fechar() {
      this.$emit("close");
    },
    generateXls() {
      let planilha = xlsx.utils.book_new();
      let cabecalho = [
        [
          ...this.colunasInscricao,
          ...this.colunasCandidato,
          ...this.colunasFormulario,
          ...this.colunasAvaliacao,
        ].map((e) => {
          return e.texto;
        }),
      ];

      this.orderby = this.orderby.map((e) => {
        if (e === "vacancie") {
          return "vacancie.title";
        } else if (e === "bonification") {
          return "bonification.title";
        } else {
          return e;
        }
      });

      this.inscriptions = this.inscriptions.map((e) => {
        if (e.vaga?.includes("Ampla")) e.vacancie.title = "Ampla Concorrência";
        return e;
      });

      this.inscriptions = arraySort(this.inscriptions, this.orderby);

      let inscriptionAuxTest = this.inscriptions.map((e) => {
        if (e.avaliationData?.length > 0) {
          e.avaliationData.forEach((i) => {
            i.avaliators = i.avaliators?.map((e) => {
              let title = i.title;
              for (const j of e.fields) {
                i[title + ": " + j.title] = isNaN(parseFloat(j.input))
                  ? j.input
                  : parseFloat(j.input);
              }

              return i;
            });
          });
        }
        return e;
      });

      let inscricao = inscriptionAuxTest.map((e) => {
        let temp = [];
        for (const c of this.colunasInscricao) {
          if (c.texto.includes("ENEM")) {
            if (e.enem_total != undefined)
              temp.push(e.enem_total[c.field.split(".")[1]]);
          } else {
            if (c.is_array) {
              temp.push(e[c.field].title);
            } else {
              temp.push(e[c.field]);
            }
          }
        }
        for (const u of this.colunasCandidato) {
          if (u.is_address) {
            temp.push(
              e.id_user[u.field.split(".")[1]].street +
                ", " +
                e.id_user[u.field.split(".")[1]].street_number +
                ", " +
                e.id_user[u.field.split(".")[1]].neighborhood
            );
          } else {
            temp.push(e.id_user[u.field.split(".")[1]]);
          }
        }
        for (const f of this.colunasFormulario) {
          if (e.inscriptionData.length > 0) {
            temp.push(
              e.inscriptionData
                .filter((e) => e.title === f.field)
                .map((e) => {
                  if (e.input && e.input.originalname) {
                    return e.input.originalname;
                  } else {
                    return e.input;
                  }
                })
            );
          }
        }
        for (const a of this.colunasAvaliacao) {
          if (e.avaliationData.length > 0) {
            let av = e.avaliationData.find((e) => {
              return e.title === a.title;
            });
            if (av) {
              let field = av.fields
                .filter((e) => {
                  return e.title === a.field;
                })
                .map((e) => {
                  return e.input;
                });
              temp.push(field);
            }
          }
        }
        return temp;
      });

      let conteudo = [...cabecalho, ...inscricao];
      let origem = 0;
      let destino = 0;

      for (let j = 0; j < this.viewby.length; j++) {
        for (let i = 0; i < conteudo[0].length; i++) {
          if (conteudo[0][i] === this.viewby[j]) {
            origem = i;
            destino = j;
            for (let k = 0; k < conteudo.length; k++) {
              conteudo[k].splice(destino, 0, conteudo[k].splice(origem, 1)[0]);
            }
          }
        }
      }

      let ws = xlsx.utils.aoa_to_sheet(conteudo);

      //if field type number
      //for em ws column ws["B2"] exemplo
      //ws["B2"].z = "#,##0";	//formato de numero
      // setWS(ws);

      planilha.SheetNames.push("Candidatos");
      planilha.Sheets["Candidatos"] = ws;
      let wbout = xlsx.write(planilha, { bookType: "xlsx", type: "binary" });
      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        `${this.ps.title.substring(0, 40)} - candidatos.xlsx`
      );
      this.fechar();
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
  },
};
</script>
<style language="css" scoped>
.my-list {
  height: calc(100vh - 500px);
  overflow-y: auto;
}
</style>
